import classNames from 'clsx';
import React from 'react';

import { PrizeCurrency } from '@swf/casino';
import type { CompactPrize, PrizeDetail } from '@swf/core/types/CasinoRaces';

import styles from './PrizeRow.scss';

interface Props {
  payout: CompactPrize;
  details: PrizeDetail;
}

const rankClasses = [null, styles.first, styles.second, styles.third, styles.fourth];

const PrizeRow: React.FC<Props> = ({ payout, details }) => {
  const { startIndex, endIndex, prize } = payout;
  const uniqueRank = startIndex === endIndex;
  const rankStyle = uniqueRank && endIndex < 5 ? endIndex : 0;
  const rank =
    startIndex === endIndex ? String(startIndex) : String(startIndex) + ' - ' + String(endIndex);

  return (
    <tr className={classNames(styles.row, rankClasses[rankStyle])}>
      <td>{rank}</td>
      <td>
        <PrizeCurrency type={details.prizeType} amount={prize} />
      </td>
    </tr>
  );
};

export default PrizeRow;
